// Temporary kill-switch: hide checkout until production PayPal keys are fixed.
export const PAYMENTS_ENABLED = true;
